// Import Complete profile teacher validation from mobile code
export const TEXT_LENGTH_LIMIT = {
  student_need_to_have: 450,
  student_need_to_have_online: 450,
  locations_of_class: 450,
  experience_on_subject: 1400,
  expected_students: 1400,
  expected_students_online: 1400,
};
export const TEXT_LENGTH_MIN_LIMIT = {
  student_need_to_have: 10,
  student_need_to_have_online: 10,
  locations_of_class: 0,
  experience_on_subject: 200,
  expected_students: 200,
  expected_students_online: 200,
};

export const getErrorMsgForKey = (key: string, length?: number): string => {
  switch (key) {
    case "zip_code":
      return "Enter a valid Zip Code";
    case "city":
    case "state":
      return "A valid Zip Code is needed";
    case "student_need_to_have_online":
    case "student_need_to_have":
      if (length && length != 0 && length < TEXT_LENGTH_MIN_LIMIT[key]) {
        return "Longer description needed";
      } else {
        return "Must be filled";
      }
    case "subject_want_to_teach":
      return "Subject must be selected from options";
    case "subject_sub_category":
      return "Enter Description";
    case "experience_on_subject":
    case "expected_students":
    case "expected_students_online":
    case "locations_of_class":
      if (length && length != 0 && length < TEXT_LENGTH_MIN_LIMIT[key]) {
        return "Longer description needed";
      }
      return "Enter Description";
    case "level_of_student":
      return "Select student level";
    case "profile_pic":
      return "Please upload your profile photo";
    case "neighborhood":
      return "Must be filled";

    case "online_type":
      return "Specify Class Type"
    default:
      return "";
  }
};

export const validateFirstStep = (
  form: { [key: string]: any },
  isValidating: boolean
): { [key: string]: string } => {
  var error: { [key: string]: string } = {};
  if (!isValidating) {
    return error;
  } else {
    Object.keys(form).map((key: string) => {
      if (
        form[key] == undefined ||
        (form[key] != undefined &&
          key == "profile_pic" &&
          form[key].uri.length == 0) ||
        form[key].length === 0
      ) {
        error[key] = getErrorMsgForKey(key);
      } else if (
        form[key] !== undefined &&
        form[key].length > 0 &&
        (key === "student_need_to_have" ||
          key === "student_need_to_have_online" ||
          key === "locations_of_class" ||
          key === "experience_on_subject" ||
          key === "expected_students_online" ||
          key === "expected_students") &&
        form[key].length < TEXT_LENGTH_MIN_LIMIT[key]
      ) {
        error[key] = getErrorMsgForKey(key, form[key].length);
      } else if (
        form[key] != undefined &&
        key == "zip_code" &&
        !/^\d{5}$/.test(form[key])
        // &&(form["city"] == undefined || form["city"].length == 0)
      ) {
        error[key] = getErrorMsgForKey(key);
      }
    });
  }
  return error;
};

// use onInput property of an input

export const numberOnly = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e?.target?.value;
  if (value) {
    e.target.value = value.replace(/[^0-9]/g, "");
  }
};
